export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'cnpj',
    caption: 'CNPJ'
  },
  {
    dataField: 'nome_empresa',
    caption: 'Nome'
  },
  {
    dataField: 'nome_fantasia',
    caption: 'Fantasia'
  },
  {
    dataField: 'responsavel',
    caption: 'Responsável'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
